var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showPinEnter)?_c('div',[(!_vm.shouldHideMainView && _vm.pageData)?_c('Pages',{attrs:{"main-data":_vm.pageData}}):_vm._e(),_c('router-view'),_c('web-push')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }